export default "__VITE_ASSET__cmJ3J_LahxYYmdf20gDC4w__"